import { parseGroupAndAction } from 'helpers/accessErrors/helpers';
import React from 'react';

import { AccessRequestLink } from './AccessRequestLink';

interface Props {
  message?: string;
  group?: string;
  action?: string;
  className?: string;
}

export const NotAuthorized: React.FC<Props> = ({ message, group, action, className }) => {
  const parsed = message ? parseGroupAndAction(message) : undefined;
  const effectiveGroup = group ?? parsed?.group;
  const effectiveAction = action ?? parsed?.action;

  return (
    <div className={className} style={{ width: '100%', textAlign: 'center' }}>
      <h1>You have no access to this page</h1>
      <h3>{message}</h3>
      <AccessRequestLink group={effectiveGroup} action={effectiveAction} />
    </div>
  );
};
